import ChipField from './ChipField'
export default ({ data, labelField }) => <div style={{ display: "flex", columnGap: 4 }}>{data.map((entry, index) => (
  <ChipField key={index} label={labelField ? entry[labelField] : entry} />
))}</div>